/**
 * Ponto de entrada único da aplicação.
 *
 * O CSS entra por import: o Vite o extrai para arquivo próprio e liga no HTML.
 * Não vira bloco embutido — `style-src 'self'` recusaria.
 *
 * Ordem importa. `tokens.css` declara as variáveis que os outros dois consomem;
 * invertida, as cores caem para o valor de reserva e a tela fica cinza, sem
 * erro nenhum no console.
 *
 * As duas folhas de tela convivem porque disputam com especificidade diferente:
 * `app.css` estiliza `body`, `signin.css` estiliza `body.entrar`. Quem põe e
 * tira essa classe conforme a rota é o gancho `useClasseNoBody`.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.jsx';

import './styles/tokens.css';
import './styles/app.css';
import './styles/signin.css';
import './styles/catalog.css';

createRoot(document.getElementById('raiz')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
